import React, { useState, useEffect, useRef } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
// @ts-ignore
import "./Navbar.css";

interface NavItem {
  dropdown?: boolean;
  label: string;
  to: string;
  title: string;
}

const navLinks: NavItem[] = [
  { label: "Home", to: "/", title: "Home" },
  { label: "Fleet", to: "/fleet", title: "Our Fleet" },
  { label: "About", to: "/about", title: "About Us" },
  {
    label: "Services",
    to: "/services",
    title: "Our Services",
    dropdown: true,
  },
  { label: "News", to: "/news", title: "News" },
  // { label: "Policies", to: "/policies", title: "Policies" },
  { label: "Contact", to: "/contact", title: "Contact Us" },
];

interface ServiceNavItem {
  label: string;
  to: string;
  title: string;
}

const popularServices: ServiceNavItem[] = [
  { label: "Group Vehicle Request", to: "/services/party-bus", title: "Request Group Transportation Availability – GS Limo Elite" },
  { label: "Wedding", to: "/services/weddings", title: "Wedding Transportation – GS Limo Elite" },
  { label: "Corporate", to: "/services/corporate-travel", title: "Corporate Travel – GS Limo Elite" },
];

interface AirportSubmenuItem {
  code: string;
  label: string;
  to: string;
  title: string;
}

const airportSubmenuItems: AirportSubmenuItem[] = [
  { code: "ALB", label: "Albany International (ALB)", to: "/services/airport-transportation/alb", title: "Albany International Airport (ALB) – GS Limo Elite" },
  { code: "ACY", label: "Atlantic City International (ACY)", to: "/services/airport-transportation/acy", title: "Atlantic City International Airport (ACY) – GS Limo Elite" },
  { code: "PHL", label: "Philadelphia International (PHL)", to: "/services/airport-transportation/phl", title: "Philadelphia International Airport (PHL) – GS Limo Elite" },
  { code: "LGA", label: "LaGuardia (LGA)", to: "/services/airport-transportation/lga", title: "LaGuardia Airport (LGA) – GS Limo Elite" },
  { code: "JFK", label: "JFK International (JFK)", to: "/services/airport-transportation/jfk", title: "John F. Kennedy International Airport (JFK) – GS Limo Elite" },
  { code: "EWR", label: "Newark Liberty International (EWR)", to: "/services/airport-transportation/ewr", title: "Newark Liberty International Airport (EWR) – GS Limo Elite" },
];

const allServicesCol1: ServiceNavItem[] = [
  { label: "Anniversaries", to: "/services/anniversaries", title: "Anniversary Transportation – GS Limo Elite" },
  { label: "Bachelor/ette Party", to: "/services/bachelorette-party", title: "Bachelor & Bachelorette Party Transportation – GS Limo Elite" },
  { label: "Birthdays", to: "/services/birthdays", title: "Birthday Party Transportation – GS Limo Elite" },
  { label: "Concerts", to: "/services/concerts", title: "Concert Transportation – GS Limo Elite" },
  { label: "Cruise Port", to: "/services/cruise-port", title: "Cruise Port Transportation – GS Limo Elite" },
  { label: "Destination", to: "/services/destination", title: "Destination Transportation – GS Limo Elite" },
];

const allServicesCol2: ServiceNavItem[] = [
  { label: "Funerals", to: "/services/funerals", title: "Funeral Transportation – GS Limo Elite" },
  { label: "Group Events", to: "/services/group-events", title: "Group Event Transportation – GS Limo Elite" },
  { label: "Hourly As Directed", to: "/services/hourly-as-directed", title: "Hourly & As-Directed – GS Limo Elite" },
  { label: "Night on the Town", to: "/services/night-on-the-town", title: "Night on the Town Transportation – GS Limo Elite" },
  { label: "Prom", to: "/services/prom", title: "Prom Transportation – GS Limo Elite" },
  { label: "School Events", to: "/services/school-events", title: "School Event Transportation – GS Limo Elite" },
  { label: "Sports Events", to: "/services/sports-events", title: "Sports Event Transportation – GS Limo Elite" },
  { label: "Wine and Sightseeing", to: "/services/wine-and-sightseeing", title: "Wine Tours & Sightseeing – GS Limo Elite" },
];

export default function Navbar(): JSX.Element {
  const { pathname } = useLocation();
  const [scrolled, setScrolled] = useState<boolean>(false);
  const [menuOpen, setMenuOpen] = useState<boolean>(false);
  const [servicesOpen, setServicesOpen] = useState<boolean>(false);
  const [airportsSubOpen, setAirportsSubOpen] = useState<boolean>(false);
  const servicesRef = useRef<HTMLLIElement | null>(null);

  useEffect(() => {
    const onScroll = (): void => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    const onDocClick = (e: MouseEvent): void => {
      if (servicesRef.current && !servicesRef.current.contains(e.target as Node)) {
        setServicesOpen(false);
        setAirportsSubOpen(false);
      }
    };
    const onKeyDown = (e: KeyboardEvent): void => {
      if (e.key === "Escape") {
        setServicesOpen(false);
        setAirportsSubOpen(false);
      }
    };
    document.addEventListener("click", onDocClick);
    document.addEventListener("keydown", onKeyDown);
    return () => {
      document.removeEventListener("click", onDocClick);
      document.removeEventListener("keydown", onKeyDown);
    };
  }, []);

  const closeMenu = (): void => {
    setMenuOpen(false);
    setServicesOpen(false);
    setAirportsSubOpen(false);
  };

    const onAirportRoute =
    pathname.indexOf("/services/airport-transportation") === 0;

  return (
    <nav
      className={`gs-navbar navbar navbar-expand-lg${scrolled ? " scrolled" : ""}`}
      id="mainNav"
    >
      <div className="container-xl px-3 px-lg-4">
        <Link
          className="navbar-brand gs-logo-wrap"
          to="/"
          onClick={closeMenu}
          title="GS Limo Elite – Home"
        >
          <img
            src={`${process.env.PUBLIC_URL}/images/gs-limo-elite-logo-dark-220-v7.webp`}
            srcSet={`${process.env.PUBLIC_URL}/images/gs-limo-elite-logo-dark-160-v7.webp 160w, ${process.env.PUBLIC_URL}/images/gs-limo-elite-logo-dark-220-v7.webp 220w`}
            sizes="(max-width: 767px) 80px, 110px"
            alt="GS Limo Elite — Luxury Transportation NJ, PA & NY"
            title="GS Limo Elite — Luxury Transportation NJ, PA & NY"
            width="110"
            height="73"
            loading="eager"
            fetchPriority="high"
          />
        </Link>

        <button
          className="navbar-toggler gs-toggler"
          type="button"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-expanded={menuOpen}
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className={`collapse navbar-collapse${menuOpen ? " show" : ""}`}>
          <ul className="navbar-nav mx-auto gap-1">
            {navLinks.map((link) =>
              link.dropdown ? (
                <li
                  key={link.to}
                  ref={servicesRef}
                  className={`nav-item dropdown gs-dropdown${servicesOpen ? " show" : ""}`}
                >
                  <div className="gs-dropdown-head d-flex align-items-center">
                    <NavLink
                      className={({ isActive }) =>
                        "nav-link" +
                        (isActive && !onAirportRoute ? " active" : "")
                      }
                      to={link.to}
                      onClick={closeMenu}
                      title={link.title}
                    >
                      {link.label}
                    </NavLink>
                    <button
                      type="button"
                      className="gs-dropdown-toggle"
                      aria-haspopup="true"
                      aria-expanded={servicesOpen}
                      aria-label="Toggle Services dropdown"
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setServicesOpen((v) => !v);
                        setAirportsSubOpen(false);
                      }}
                    >
                      <i
                        className={`fas fa-chevron-down${servicesOpen ? " open" : ""}`}
                      ></i>
                    </button>
                  </div>
                  <div
                    className={`dropdown-menu gs-dropdown-menu gs-mega-menu${servicesOpen ? " show" : ""}`}
                    aria-label={link.title}
                  >
                    <div className="gs-mega-cols">
                      <div className="gs-mega-col gs-mega-col-popular">
                        <p className="gs-mega-col-title">Most Popular</p>
                        {popularServices.map((service) => (
                          <NavLink
                            key={service.to}
                            className={({ isActive }) =>
                              "dropdown-item gs-dropdown-item" +
                              (isActive ? " active" : "")
                            }
                            to={service.to}
                            onClick={closeMenu}
                            title={service.title}
                          >
                            {service.label}
                          </NavLink>
                        ))}
                      </div>
                      <div className="gs-mega-col gs-mega-col-all">
                        <p className="gs-mega-col-title">All Services</p>
                        <div className="gs-mega-subcols">
                          <div className="gs-mega-subcol">
                            {allServicesCol1.map((service) => (
                              <NavLink
                                key={service.to}
                                className={({ isActive }) =>
                                  "dropdown-item gs-dropdown-item" +
                                  (isActive ? " active" : "")
                                }
                                to={service.to}
                                onClick={closeMenu}
                                title={service.title}
                              >
                                {service.label}
                              </NavLink>
                            ))}
                          </div>
                          <div className="gs-mega-subcol">
                            <div className={`gs-submenu${airportsSubOpen ? " open" : ""}`}>
                              <div className="gs-submenu-head">
                                <NavLink
                                  className={({ isActive }) =>
                                    "dropdown-item gs-dropdown-item" +
                                    (isActive ? " active" : "")
                                  }
                                  to="/airports"
                                  onClick={closeMenu}
                                  title="Airport Transfers – GS Limo Elite"
                                >
                                  Airport Transportation
                                </NavLink>
                                <button
                                  type="button"
                                  className="gs-submenu-toggle"
                                  aria-haspopup="true"
                                  aria-expanded={airportsSubOpen}
                                  aria-label="Toggle Airport Transportation submenu"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    setAirportsSubOpen((v) => !v);
                                  }}
                                >
                                  <i
                                    className={`fas fa-chevron-down${airportsSubOpen ? " open" : ""}`}
                                  ></i>
                                </button>
                              </div>
                              <ul
                                className="gs-submenu-menu"
                                aria-label="Airport Transportation submenu"
                              >
                                {airportSubmenuItems.map((airport) => (
                                  <li key={airport.code}>
                                    <NavLink
                                      className={({ isActive }) =>
                                        "dropdown-item gs-submenu-item" +
                                        (isActive ? " active" : "")
                                      }
                                      to={airport.to}
                                      onClick={closeMenu}
                                      title={airport.title}
                                    >
                                      {airport.label}
                                    </NavLink>
                                  </li>
                                ))}
                              </ul>
                            </div>
                            {allServicesCol2.map((service) => (
                              <NavLink
                                key={service.to}
                                className={({ isActive }) =>
                                  "dropdown-item gs-dropdown-item" +
                                  (isActive ? " active" : "")
                                }
                                to={service.to}
                                onClick={closeMenu}
                                title={service.title}
                              >
                                {service.label}
                              </NavLink>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              ) : (
                <li className="nav-item" key={link.to}>
                  <NavLink
                    className={({ isActive }) =>
                      "nav-link" + (isActive ? " active" : "")
                    }
                    to={link.to}
                    onClick={closeMenu}
                    end={link.to === "/"}
                    title={link.title}
                  >
                    {link.label}
                  </NavLink>
                </li>
              ),
            )}
          </ul>
          <div className="gs-nav-right d-flex align-items-center  gap-3">
            <Link
              to="/get-a-quote"
              className="btn gs-btn-gold px-3 py-2"
              onClick={closeMenu}
              title="Get a Quote"
            >
              Get a Quote
            </Link>
            <a
              href="tel:9294526031"
              className="nav-phone"
              title="Call GS Limo Elite at (929) 452-6031"
            >
              <i className="fas fa-phone me-1"></i> (929) 452-6031
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
}
